<div class="page-wrapper">
  <!-- Hero Section -->
  <div class="landing-container">
    <div class="content-wrapper">
      <h1 class="main-title">Before Your Next</h1>
      <div class="investment-pill">
        <span>{{ typedText }}<span class="typing-cursor">|</span></span>
      </div>
      <h2 class="sub-title">Talk to <strong>Bajaj Capital.</strong></h2>
      <p class="description">Get expert guidance before making your next financial decision.</p>
      
      <button class="cta-button" (click)="openExpertLeadModal()">
        <!-- Speech bubble SVG icon -->
        <svg class="chat-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
        </svg>
        Talk to an Expert <span class="arrow">&gt;</span>
      </button>
    </div>
  </div>

  <!-- Why Millions Trust Section -->
  <section class="trust-section">
    <div class="trust-container">
      <h2 class="trust-title">Why Millions Trust Bajaj Capital?</h2>
      <p class="trust-description">
        For over <strong>60 years</strong>, Bajaj Capital has helped millions of Indians make smarter financial decisions. Whether you're investing, planning for retirement, reviewing your portfolio, or choosing the right insurance, our experts provide personalized guidance tailored to your financial goals.
      </p>
      
      <!-- Stats Row -->
      <div class="trust-stats-row">
        <div class="stat-item">
          <div class="stat-number">60+ <span class="stat-label-inline">Years</span></div>
          <div class="stat-desc">of Trusted Financial Expertise</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">4.1 <span class="stat-label-inline">Million+</span></div>
          <div class="stat-desc">Customers Served</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">110+ <span class="stat-label-inline">Branches</span></div>
          <div class="stat-desc">Across India</div>
        </div>
      </div>
      
      <!-- Icons Row -->
      <div class="trust-icons-row">
        <div class="trust-icon-item">
          <img src="../../../assets/images/new-investment/personalized.svg" alt="Personalized" class="trust-icon-img">
          <div class="trust-icon-text">
            <strong>Personalized</strong>
            <span>Financial Advice</span>
          </div>
        </div>
        <div class="trust-icon-item">
          <img src="../../../assets/images/new-investment/handshake.svg" alt="One Partner" class="trust-icon-img">
          <div class="trust-icon-text">
            <strong>One Partner</strong>
            <span>for All Your Financial Needs</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- What Can We Help You With Section -->
  <section class="services-section">
    <div class="services-container">
      <h2 class="services-title">What Can We Help You With?</h2>
      
      <!-- Row 1 -->
      <div class="services-row row-1">
        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/mutual_funds.svg" alt="Mutual Funds & SIPs">
          </div>
          <h4>Mutual Funds <br>&amp; SIPs</h4>
        </div>
        
        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/retirement.svg" alt="Retirement Planning">
          </div>
          <h4>Retirement <br>Planning</h4>
        </div>

        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/portfolio.svg" alt="Portfolio Review">
          </div>
          <h4>Portfolio <br>Review</h4>
        </div>

        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/insurance.svg" alt="Health & Life Insurance">
          </div>
          <h4>Health &amp; Life <br>Insurance</h4>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="services-row row-2">
        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/wealth.svg" alt="Wealth Creation">
          </div>
          <h4>Wealth <br>Creation</h4>
        </div>

        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/tax_savings.svg" alt="Tax Saving Investments">
          </div>
          <h4>Tax Saving <br>Investments</h4>
        </div>

        <div class="service-card" (click)="openLeadModal()">
          <div class="service-icon-wrapper">
            <img src="../../../assets/images/new-investment/goal_based_planning.svg" alt="Goal-Based Financial Planning">
          </div>
          <h4>Goal-Based <br>Financial Planning</h4>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact Banner Section -->
  <div class="contact-banner">
    <div class="contact-banner-content">
      <div class="contact-left">
        <img class="contact-img" src="../../../assets/images/new-investment/contact_image.png"
             srcset="../../../assets/images/new-investment/contact_image.png 1x,
                     ../../../assets/images/new-investment/contact_image@2x.png 2x"
             width="72" height="48" alt="Contact Expert">
        <div class="contact-text">
          <h3>Every financial journey begins with the right guidance.</h3>
          <p>Talk to Bajaj Capital.</p>
        </div>
      </div>
      <button class="cta-button rounded-cta" (click)="openExpertLeadModal()">
        <svg class="chat-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
        </svg>
        Talk to an Expert <span class="arrow">&gt;</span>
      </button>
    </div>
  </div>

  <!-- Footer Section -->
  <footer class="disclaimer-footer">
    <div class="footer-container">
      <div class="footer-link">
        <a href="https://www.bajajcapital.com" target="_blank">www.bajajcapital.com</a>
      </div>
      <p class="terms">
        <span style="font-weight: bold;">Disclaimer:</span> Bajaj Capital Limited ("BCL") CIN: U67120DL1965PLC004338 having its registered office at Mezzanine Floor 97 Bajaj House, Nehru Place, New Delhi DL, 110019 is a mutual fund distributor (ARN 0010) registered with AMFI. Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness and adequacy. The content of the material including images, charts, graphics and pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed or distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract appropriate legal action. <strong>Mutual Fund investments are subject to market risk, read all scheme-related documents carefully.</strong> The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.
      </p>
    </div>
  </footer>

  <!-- Sleek Modal for Lead Capture -->
  <div class="modal-overlay" *ngIf="isModalVisible" (click)="closeLeadModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeLeadModal()">&times;</button>
      
      <!-- Lead Form Screen -->
      <div *ngIf="isLeadFormVisible">
        <h3 class="modal-heading">Request Expert Guidance</h3>
        <p class="modal-subheading">Enter your details and our expert will get in touch shortly.</p>
        
        <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
          <div class="form-group">
            <label for="name">Full Name</label>
            <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name" 
                   class="form-control" (blur)="removeErrorMsg('name')" placeholder="Enter your full name" 
                   maxlength="40" (keydown)="alphaOnly($event)">
            <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
              Invalid full name
            </div>
            <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
              Full name is mandatory
            </div>
          </div>

          <div class="form-group">
            <label for="email">Email Address</label>
            <input type="email" autocomplete="off" (keydown.space)="$event.preventDefault()" id="email" name="email" 
                   [(ngModel)]="email" class="form-control" (blur)="removeErrorMsg('email')" placeholder="Enter your email id" 
                   maxlength="50">
            <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
              Invalid email address
            </div>
            <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
              Email address is mandatory
            </div>
          </div>

          <div class="form-group">
            <label for="mobile">Mobile Number</label>
            <input type="text" (keydown.space)="$event.preventDefault()" autocomplete="off" id="mobile" name="mobile" 
                   [(ngModel)]="mobile" class="form-control" placeholder="10-digit mobile number" 
                   minlength="10" maxlength="10" (blur)="removeErrorMsg('mobile')" (keypress)="numbersOnly($event)">
            <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
              10 digit mobile number is mandatory
            </div>
            <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
              Invalid mobile number
            </div>
            <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
              Mobile number is mandatory
            </div>
          </div>

          <div class="form-group">
            <label for="pincode">Pincode</label>
            <input type="text" autocomplete="off" id="pincode" name="pincode" [(ngModel)]="pincode" 
                   class="form-control" placeholder="Enter 6-digit pincode" minlength="6" maxlength="6"
                   (click)="openSuggestionBox($event,'form')" (blur)="hideSuggestionDiv('form')"
                   (keyup)="getPincodeList($event,'form')" (keypress)="numberspincode($event)">
            <div class="errormsg" *ngIf="pinValidateMessage == 'invalid'">
              Invalid pincode
            </div>
            <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
              Pincode is mandatory
            </div>

            <!-- Suggestions -->
            <div class="suggestion-box" *ngIf="hideSuggestion && pincodeArr.length > 0">
              <div *ngFor="let pin of pincodeArr" class="suggestion-item" (mousedown)="setpincode(pin,'form')">
                {{pin.pincode}} - {{pin.cityname}}
              </div>
            </div>
          </div>

          <button type="submit" class="submit-button">Send OTP</button>
        </form>
      </div>

      <!-- OTP Verification Screen -->
      <div *ngIf="isOtpFormVisible">
        <h3 class="modal-heading">Verify Mobile</h3>
        <p class="modal-subheading">We have sent an OTP to your mobile ending with {{mobile ? mobile.substring(6) : ''}}</p>

        <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
          <div class="form-group">
            <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault()" 
                   id="otp" name="otp" [(ngModel)]="userOTP" class="form-control text-center" 
                   maxlength="6" placeholder="Enter 6-Digit OTP" (keypress)="numberspincode($event)"
                   (keyup)="removeErrorMsg('otp')">
            <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
              OTP is required
            </div>
            <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">
              OTP must be 6 digits
            </div>
            <div class="errormsg" *ngIf="!otpVerifiedStatus">
              Invalid OTP, please try again
            </div>
          </div>

          <div class="otp-actions">
            <span *ngIf="isTimer" class="timer-text">Didn't receive OTP? Resend in <strong>{{timeleft}}s</strong></span>
            <a class="resend-link" href="javascript:void(0)" *ngIf="isResend" (click)="resendOTP()">Resend OTP</a>
            <a class="change-num" href="javascript:void(0)" (click)="changeNumber()">Change Number</a>
          </div>

          <button type="submit" id="otp_verify_btn" class="submit-button">Verify & Submit</button>
        </form>
      </div>

      <!-- Success Screen -->
      <div *ngIf="isThanksVisible" class="success-screen">
        <div class="success-icon">&#10004;</div>
        <h3 class="modal-heading">Thank You!</h3>
        <p class="modal-subheading">Our investment expert will contact you shortly.</p>
        <button class="submit-button" (click)="closeLeadModal()">Done</button>
      </div>

    </div>
  </div>
</div>
